import { useTranslation } from "react-i18next";

import { useLatestIngestions } from "shared/api/ingestion/hooks";
import { useConfigContext } from "shared/contexts/ConfigContext";

import { INGESTION_INFO_PAGE_CONFIG_KEY } from "pages/SuperAdmin/PagesConfig/types";

import { IngestionEntriesState } from "./constants";
import { getLatestIngestionViews, toIngestionEntry } from "./utils";

export const useIngestionEntries = (): IngestionEntriesState => {
  const { t } = useTranslation();
  const { pages, userInfo } = useConfigContext();
  const { data, error } = useLatestIngestions(
    { skipRequest: !pages[INGESTION_INFO_PAGE_CONFIG_KEY] },
    getLatestIngestionViews(pages, userInfo.isSuperAdmin)
  );

  // Mapped on every render rather than memoized, so "today" and "yesterday" stay right past midnight.
  const entries =
    data?.map((ingestion) => toIngestionEntry(ingestion, t)) ?? null;

  // A failed revalidation keeps the previous data, which is still worth showing.
  return { entries, failed: Boolean(error) && !data };
};
